
export type TweetListResponsePageAllOfThreeContentItemReferencedTweetType = typeof TweetListResponsePageAllOfThreeContentItemReferencedTweetType[keyof typeof TweetListResponsePageAllOfThreeContentItemReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetListResponsePageAllOfThreeContentItemReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
